import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const zhTwTranslations: PluginDefaultTranslationsObject = {
  $schema: './翻譯-schema.json',
  'plugin-form-builder': {
    name: '名稱（小寫，無特殊字元）',
    add: '添加',
    allowedFileTypes: '允許的文件類型',
    allowedFileTypesDescription:
      '限制允許的檔案類型（例如圖像/*、應用程式/pdf）。留空以允許所有類型。',
    allowMultipleFiles: '允許多個文件',
    amountInCents: '金額以美分為單位',
    basePrice: '基本價格',
    bcc: '密件副本',
    brand: '品牌',
    cc: '副本',
    checkboxPlural: '複選框字段',
    checkboxSingular: '複選框',
    checkedByDefault: '預設勾選',
    chooseConfirmationType: '選擇在提交表單後是顯示頁面訊息還是重定向到其他頁面。',
    condition: '條件',
    confirmationMessage: '確認訊息',
    confirmationType: '確認類型',
    countryPlural: '鄉村田野',
    countrySingular: '國家',
    creditCard: '信用卡',
    customURL: '自訂網址',
    datePlural: '日期字段',
    dateSingular: '日期',
    defaultValue: '預設值',
    divide: '劃分',
    documentToLinkTo: '要連結到的文檔',
    doesNotEqual: '不等於',
    emailFrom: '電子郵件寄件人',
    emailPlural: '電子郵件字段',
    emailsDescription:
      '提交表單時發送自訂電子郵件。使用逗號分隔清單將同一封電子郵件傳送給多個收件者。若要引用此表單中的值，請用雙大括號將該欄位的名稱括起來，即 {{firstName}}。您可以使用通配符 {{*}} 輸出所有數據，並使用 {{*:table}} 將其格式化為電子郵件中的 HTML 表格。',
    emailSingular: '電子郵件',
    emailTo: '發送電子郵件至',
    equals: '等於',
    field: '領域',
    fields: '領域',
    fieldWidth: '欄位寬度（百分比）',
    hasAnyValue: '有任何價值',
    internalLink: '內部連結',
    label: '標籤',
    maxFileSize: '最大檔案大小（位元組）',
    maxFileSizeDescription: '最大檔案大小（以位元組為單位）。留空則無限制。',
    message: '留言',
    messageDescription: '輸入應在此電子郵件中發送的訊息。',
    messagePlural: '訊息區塊',
    messageSingular: '留言',
    mimeType: 'MIME 類型',
    mimeTypePlural: 'MIME 類型',
    mimeTypeSingular: 'MIME 類型',
    multiply: '乘法',
    numberPlural: '數位字段',
    numberSingular: '數量',
    optionPlural: '選項',
    optionSingular: '選項',
    paymentFieldPlural: '付款字段',
    paymentFieldSingular: '付款方式',
    paymentProcessor: '支付處理器',
    paymentStatus: '狀態',
    placeholder: '佔位符',
    priceConditions: '價格條件',
    priceConditionsPlural: '價格條件',
    priceConditionsSingular: '價格條件',
    radioOptions: '無線電屬性選項',
    radioPlural: '無線電場',
    radioSingular: '收音機',
    redirect: '重定向',
    replyTo: '回覆',
    required: '必填',
    selectOptions: '選擇選項',
    selectPlural: '選擇字段',
    selectSingular: '選擇',
    statePlural: '狀態欄位',
    stateSingular: '狀態',
    staticValue: '靜態值',
    subject: '主題',
    submitButton: '提交按鈕標籤',
    subtract: '減去',
    textareaPlural: '文字區域字段',
    textareaSingular: '文字區',
    textPlural: '文字欄位',
    textSingular: '文字',
    title: '標題',
    token: '代幣',
    uploadCollection: '上傳收藏',
    uploadCollectionDescription: '選擇要儲存檔案的上傳集合',
    uploadFieldPlural: '上傳欄位',
    uploadFieldSingular: '上傳',
    urlToRedirectTo: '要重新導向到的 URL',
    value: '價值',
    valueOfField: '欄位值',
    valueType: '值類型',
  },
}

export const zhTw: PluginLanguage = {
  dateFNSKey: 'zh-TW',
  translations: zhTwTranslations,
}
